import * as MaxAds from './applovin_max.js';
import { NetworkManager } from '../network_manager.js';

const LOG_TAG = '[ADS_FIRST_LOAD]';
const REWARDED_FIRST_LOAD_TIMEOUT_MS = 12_000;
const BACKGROUND_PRELOAD_TIMEOUT_MS = 60_000;

const rewarded_state = { in_progress: false };

export async function isRewardedReady(): Promise<boolean>
{
  try
  {
    const { available } = await MaxAds.isRewardedAvailable();
    return !!available;
  }
  catch
  {
    return false;
  }
}

async function loadRewarded( timeout_ms: number ): Promise<boolean>
{
  if ( await isRewardedReady() )
    return true;

  if ( !NetworkManager.isOnline() )
  {
    console.log( `${LOG_TAG} offline, rewarded load skipped` );
    return false;
  }

  if ( rewarded_state.in_progress )
  {
    const waited_from = Date.now();
    while ( rewarded_state.in_progress && Date.now() - waited_from < timeout_ms )
    {
      if ( await isRewardedReady() )
        return true;
      await new Promise( r => setTimeout( r, 200 ) );
    }
    return isRewardedReady();
  }

  rewarded_state.in_progress = true;
  try
  {
    if ( !await MaxAds.ensureLazyInit() )
      return false;

    await MaxAds.prepareRewarded();

    const started = Date.now();
    while ( Date.now() - started < timeout_ms )
    {
      if ( await isRewardedReady() )
        return true;
      await new Promise( r => setTimeout( r, 200 ) );
    }

    console.warn( `${LOG_TAG} rewarded load timeout` );
    return false;
  }
  catch ( e )
  {
    console.error( `${LOG_TAG} rewarded load error`, e );
    return false;
  }
  finally
  {
    rewarded_state.in_progress = false;
  }
}

export function loadRewardedFirstTime(): Promise<boolean>
{
  return loadRewarded( REWARDED_FIRST_LOAD_TIMEOUT_MS );
}

export function preloadInterstitialInBackground(): void
{
  if ( !MaxAds.isNative() || !NetworkManager.isOnline() ) return;
  void MaxAds.prepareInterstitial();
}

export function preloadAdsInBackground(): void
{
  void loadRewarded( BACKGROUND_PRELOAD_TIMEOUT_MS );
  preloadInterstitialInBackground();
}
